export const aboutMissionVisionSectionStyles = {
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
    backgroundColor: 'primary.main',
  },
  headerContainer: {
    position: 'relative',
    zIndex: 2,
    padding: {
      md: '35px 75px',
      xs: "20px"
    },
  },
  sectionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  halfSection: {
    position: 'relative',
    display: 'flex',
    flexDirection: {xs: 'column', md: 'row'},
    alignItems: 'center',
    justifyContent: 'space-between',
    height: {xs: "100%", md: '100vh'},
    overflow: 'hidden',
  },
  halfSectionBottom: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: {xs: "100%", md: '100vh'},
    overflow: 'hidden',
  },
  waveBackground: (waveUrl) => ({
    position: 'absolute',
  
    top: '-30%',
    right: '-20%',
    width: '100vw',
    height: '100vh',
    backgroundImage: `url(${waveUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat',
    zIndex: 0,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(134.54deg, rgba(0, 68, 63, 0) 39.12%, #00443F 63.49%)',
      pointerEvents: 'none',
    },
  }),
  waveBackgroundRotated: (waveUrl) => ({
    position: 'absolute',
    top: "-50%",
    right: '-240px',
    width: '100vw',
    height: '100vh',
    backgroundImage: `url(${waveUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat',
    transform: 'scaleX(-1) rotate(-180deg)',
    transformOrigin: 'center',
    zIndex: 0,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(134.54deg, rgba(0, 68, 63, 0) 39.12%, #00443F 63.49%)',
      pointerEvents: 'none',
    },
  }),
  halfSectionReverse: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100vh',
  },
  textColumn: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 2,
  },
  imageColumn: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 2,
    paddingTop: {xs: "100px", md: 0},
  },
  visionTextColumn: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 2,
    order: {xs: 1, md: 2},
  },
  visionImageColumn: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 2,
    marginBottom: 0,
    paddingBottom: 0,
    order: {xs: 2, md: 1},
  },
  imageWrapper: {
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    marginBottom: 0,
  },
  image: {
    width: '150%',
    height: '100%',
    objectFit: 'contain',
    zIndex: 1,
    marginBottom: 0,
    paddingBottom: 0,
  },
  image2: {
    width:{xs: "100%", md: '100%'},
    height:{xs: "100%", md: '100%'},
    objectFit: "cover",
    zIndex: 1,
    transform: 'scaleX(-1)',
  },
  image2Wrapper: {
    width: '120%',
    height:'100%',
    marginTop: '10%',
    marginLeft: '-20%',
  },
  infoCard1: {
    position: 'absolute',
    top:{xs: '15%', md: '25%'},
    right: {xs: '10%', md: '20%'},
    zIndex: 3,
  },
  infoCard2: {
    position: 'absolute',
    top:{xs: '40%', md: '40%'},
    left:{xs: '10%', md: '20%'},
    zIndex: 3,
  },
  infoCard3: {
    position: 'absolute',
    top:{xs: '10%', md: '30%'},
    right:{xs: '15%', md: '60%'},
    zIndex: 3,
  },
};




